import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const GroupGratuityFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. Is Group Gratuity Compulsory?",
      answer: (
        <>
          <span style={{ color: "#F37435", fontWeight: "700"}}>Yes,</span> the Group Gratuity Scheme is compulsory in certain states in India:
         The states of Karnataka, Telangana and Andhra Pradesh have implemented
         compulsory Gratuity Insurance Rules that mandate employers to set up an insurance
         fund for paying gratuity to their employees. 

         <span style={{ color: "#F37435", fontWeight: "700"}}>These compulsory gratuity insurance rules apply to:</span>
          1.Factories, mines, oilfields, plantations, ports and railway companies
          2.Shops and establishments with 10 or more employees
          3.Establishments not under the control of the Central Government or State Government
        </>
      )
    },
    {
      question: "Q2. When is an Employee Eligible for Gratuity?",
      answer: (
        <>
         An employee is eligible for gratuity under the Payment of Gratuity Act, 1972 in India  when they meet one of the following conditions:
         <span style={{ color: "#F37435", fontWeight: "700"}}>Completing 5 years of continuous service:</span> This is the most common scenario.  The employee must have worked for the same employer for at least five full years without any major breaks in service.
          Death: If an employee dies while employed by the company, irrespective of the duration of service, their gratuity is payable to their nominee or legal heir.
          Disability: In case of permanent disability due to illness or accident, the employee becomes eligible for gratuity regardless of the number of years served.
       </>
      )
    },
    {
      question: "Q3. Can an Employee Withdraw from the Gratuity Fund?",
      answer:(
        <>
       <span style={{ color: "#F37435", fontWeight: "700"}}>No, </span>an employee cannot directly withdraw from the gratuity fund in India. The gratuity fund is not like a personal savings account that employees contribute to. It's a liability set aside by the employer to pay employees their gratuity entitlement upon meeting certain conditions.
      </>
      )
      },

      {
        question: "Q4. Is Gratuity Payable to an Employee on Probation?",
        answer:(
          <>
         <span style={{ color: "#F37435", fontWeight: "700"}}>Yes, gratuity is payable to an employee who has completed at least 5 years of
         continuous service, including the probation period. </span>The length of service is calculated from the date of joining, including the probation period.
        Employers cannot exclude the probation period while calculating an employee’s length of service for gratuity. The entire duration of the employee’s continuous service, starting from the date of joining, must be considered for determining gratuity eligibility.
        </>
        )
        },
    {
      question: "Q5. Is Gratuity Payable to Employees on Maternity Leave?",
      answer: (
        <>
        <span style={{ color: "#F37435", fontWeight: "700"}}> Yes, </span> the period of maternity leave is considered as continuous service for the
        purpose of gratuity eligibility. Employees on maternity leave are entitled to receive
        gratuity upon termination of employment, provided they have completed the
        minimum 5 years of continuous service.
        </>
      )
      
    
    },
    {
      question: "Q6. How do leaves of absence affect gratuity eligibility?",
      answer: (
        <>
          The impact of leaves on gratuity can vary depending on the specific leave type and company policy. Here are some general points:
          <br></br><span style={{ color: "#F37435", fontWeight: "700"}}>• Approved leaves (sick leave, vacation):</span>These periods might be counted towards total service for gratuity calculation in some cases.
          <br></br><span style={{ color: "#F37435", fontWeight: "700"}}>• Long leaves (sabbatical): </span> Extended leaves of absence might require special considerations. Company policy or relevant labor laws will determine if these leaves are counted as service time.
          <br></br><span style={{ color: "#F37435", fontWeight: "700"}}>•  Leave without pay:</span>  Leaves without pay typically wouldn't be counted as service time for gratuity purposes.
        </>
      )
      
    },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default GroupGratuityFAQ;